<ng-container *ngIf="cardInfo() as cardInfo">
  <mat-card>
    <mat-card-header [style.margin-left]="!showAvatar ? (AVATAR_WIDTH + 16).toString() + 'px' : null">
      <div matCardAvatar>
        <glxy-avatar
          [width]="AVATAR_WIDTH"
          icon="monetization_on"
          backgroundColor="white"
          textColor="#9E9E9E"
        ></glxy-avatar>
      </div>
      <mat-card-title>
        <span class="title">{{ cardInfo.headerText }}</span>
      </mat-card-title>
      <mat-card-subtitle>
        <p *ngIf="cardInfo.effectiveDate !== null" class="effective-date">
          {{ cardInfo.effectiveDate | date: dateFormat }}
        </p>
      </mat-card-subtitle>
    </mat-card-header>
    <mat-card-content [style.margin-left]="(AVATAR_WIDTH + 18).toString() + 'px'">
      <div *ngIf="cardInfo.activityInfo as activityInfo">
        <div class="opportunity-name">{{ activityInfo.opportunityName }}</div>
        <div class="activity-info" *ngIf="activityInfo.status">
          {{ 'COMPANY.OPPORTUNITY_CHANGE_ACTIVITY.STATUS_CHANGE_MESSAGE' | translate }}
          <span
            class="activity-info-content"
            [ngClass]="{
              'closed-lost': activityInfo.status === 'Closed-lost',
              'closed-won': activityInfo.status === 'Closed-won'
            }"
            >{{ activityInfo.status }}</span
          >
        </div>
        <div *ngIf="!isClosedWon">
          <div class="activity-info" *ngIf="activityInfo.status">
            {{ 'COMPANY.OPPORTUNITY_CHANGE_ACTIVITY.REASON_MESSAGE' | translate }}
            <span class="activity-info-content">{{ activityInfo.lostReason }}</span>
          </div>
        </div>
        <div class="action-info" *ngIf="activityInfo.notes">
          {{ 'COMPANY.OPPORTUNITY_CHANGE_ACTIVITY.NOTES_MESSAGE' | translate }}
          <span class="activity-info-content">{{ activityInfo.notes }}</span>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</ng-container>
